<template>
<b-container>
 <b-row class="justify-content-md-center">
 <b-col></b-col>
<b-col  cols="12" md="auto">
  <b-card class="mt-3" header="Dados da Minha Conta"
        header-bg-variant="primary"
        header-text-variant="white"
  >
  <b-spinner v-show="loading" variant="success" ></b-spinner>
    <form class="form was-validated" @submit="onSubmit">
      <div class="form-row">
        <act-rotulo nome="Nome" col="col-md-12">
          <input
            type="text"
            class="form-control"
            v-model="cliente.nome"
            required
          />
        </act-rotulo>
        <act-rotulo nome="Email" col="col-md-12">
          <input
            type="email"
            class="form-control"
            v-model="cliente.email"
            required
          />
        </act-rotulo>
        <act-rotulo v-show="!Logado" nome="Senha" col="col-md-12">
          <input
            type="password"
            class="form-control"
            v-model="cliente.senha"
            
          />
        </act-rotulo>
      </div>

      <div class="form-row">
        <act-rotulo nome="Tipo Pessoa" col="col-md-12">
          <div>
            <input type="radio" value="J" v-model="cliente.tipopessoa" />
            Pessoa Jurídica
          </div>
          <div>
            <input type="radio" value="F" v-model="cliente.tipopessoa" />
            Pessoa Física
          </div>
        </act-rotulo>
        <act-rotulo v-if="cliente.tipopessoa == 'F'" nome="CPF" col="col-md-12">
          <input
            v-maska="'###.###.###-##'"
            v-bind:class="[classeInput, cpfClass]"
            v-model="cliente.cpf"
            @change="altcpf"
          />
          <div class="invalid-feedback">Por favor, informe um cpf válido.</div>
        </act-rotulo>
        <act-rotulo v-else nome="Cnpj" col="col-md-12">
          <input
            v-maska="'##.###.###/####-##'"
            v-bind:class="[classeInput, cnpjClass]"
            v-model="cliente.cnpj"
            @change="altcnpj"
          />
          <div class="invalid-feedback">Por favor, informe um cnpj válido.</div>
        </act-rotulo>
        <act-rotulo
          v-show="cliente.tipopessoa == 'J'"
          nome="Razão Social"
          col="col-md-12"
        >
          <input
            type="text"
            class="form-control"
            v-model="cliente.razao"
            
          />
        </act-rotulo>
        <act-rotulo nome="CEP" col="col-md-12">
          <input
            v-maska="'#####-###'"
            class="form-control"
            v-model="cliente.cep"
            @change="pegaEndereco"
            required
          />
        </act-rotulo>
      </div>
      <div class="form-row">
        <act-rotulo nome="Endereco" col="col-md-12">
          <input
            type="text"
            class="form-control"
            v-model="cliente.endereco"
            required
          />
        </act-rotulo>
        <act-rotulo nome="Número" col="col-md-6">
          <input type="text" class="form-control" v-model="cliente.endnum" />
        </act-rotulo>
        <act-rotulo nome="Complemento" col="col-md-6">
          <input type="text" class="form-control" v-model="cliente.compl" />
        </act-rotulo>
        <act-rotulo nome="Bairro" col="col-md-12">
          <input
            type="text"
            class="form-control"
            v-model="cliente.bairro"
            required
          />
        </act-rotulo>
      </div>
      <div class="form-row">
        <act-rotulo nome="cidade" col="col-md-12">
          <input
            type="text"
            class="form-control"
            v-model="cliente.cidade"
            required
          />
        </act-rotulo>
        <act-rotulo nome="Estado" col="col-md-6">
          <input
            type="text"
            class="form-control"
            v-model="cliente.uf"
            required
          />
        </act-rotulo>
        <act-rotulo nome="Tel Comercial" col="col-md-12">
          <input
            v-maska="['(##)####-####', '(##)#####-####']"
            class="form-control"
            v-model="cliente.telcom"
          />
        </act-rotulo>
        <act-rotulo nome="Celular" col="col-md-12">
          <input
            v-maska="'(##)#####-####'"
            class="form-control"
            v-model="cliente.celular"
          />
        </act-rotulo>
      </div>
      <br>

      <b-form-checkbox
      id="checkbox-1"
      v-model="privacidade"
      name="checkbox-1"
      value="accepted"
      unchecked-value="not_accepted"
    >
      Ao enviar meus dados eu concordo com a <a href="#" v-on:click.self.prevent="$bvModal.show('modalpolitica_1')">politica de privacidade</a>
    </b-form-checkbox>

    
      <b-button v-show="privacidade == 'accepted'" type="submit" variant="primary">{{labelBotao}}</b-button>
      <b-alert class='mt-3' v-bind:show="temmsg" v-bind:variant="classemsg"> {{mensagem}}</b-alert>
    </form>
  </b-card>
</b-col>
<b-col></b-col>
 </b-row>

<act-politica-privacidade
:id='idmodal'
:texto='politicatexto'

>
</act-politica-privacidade>

</b-container>  
</template>

<script>

import ActRotulo from "./ActRotulo.vue"
import ActPoliticaPrivacidade from "./ActPoliticaPrivacidade.vue"
export default {
  components: {
     ActRotulo,
     ActPoliticaPrivacidade
  },  
  data() {
    return {
      cliente: {
        id:0,
        nome: "",
        cpf: "",
        cnpj: "",
        razao: "",
        email: "",
        senha: "",
        tipopessoa: "J",
        endereco: "",
        endnum: "",
        compl: "",
        bairro: "",
        cidade: "",
        uf: "",
        cep: "",
        telcom: "",
        celular: "",
        
      },
      cpfClass: "",
      cnpjClass: "",
      classeInput: "form-control",
      loading: false,
      error: "",
      labelBotao:"Enviar",
      idmodal:"1"
     
    }
  },

  computed: {
        contacriada() {
          return this.$store.getters.getContaCriada
        },
        mensagem() {
            return this.$store.getters.getMsgConta
        },
        temmsg() {
            let aux = this.mensagem
            if (aux.length > 0) {
                return true
            } else {
                return false
            }
        },
        Logado() {
          return this.$store.getters.getLogado
        },
        politicatexto() {
           return this.$store.getters.getPoliticaTexto
        },
       
        privacidade: {
           get() {
             return this.$store.getters.getPolitica
           },
           set (valor) {
              this.$store.commit('setPolitica',valor)
           }

        },
        ClientId() {
          return this.$store.getters.getClientId
        },
        
        classemsg() {
            if (this.contacriada) {
                return "success"
            } else {
               return "danger"   
            }
        }
  },
  watch: {
    
      ClientId: function(newValue) {
          if (newValue > 0) {
            this.labelBotao = "Alterar"
            this.cliente.id = newValue
            this.getDadosConta(newValue)

          }
      }    
  },
  methods: {
    onSubmit(event) {
        event.preventDefault()

        if ((this.cliente.tipopessoa == 'J') && (this.cliente.cnpj == '')) {
          alert("Preencha CNPJ");
          return false
        }
        if ((this.cliente.tipopessoa == 'F') && (this.cliente.cpf == '')) {
          alert("Preencha CPF");
          return false
        }
        //console.log(this.cliente)
        this.id = this.ClientId
        this.$store.dispatch('criarconta',this.cliente)
            
    }, 

    getDadosConta(id) {
      this.loading = true;
      const url = process.env.VUE_APP_BACKEND + "ajax_get_conta.php?id="+id;
      //console.log(url);
      fetch(url)
        .then((response) => {
          //console.log(response);
          if (response.ok) {
            return response.json();
          }
        })
        .then((data) => {
          this.cliente = data;
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.error = error;
        });
    },


    cpfValido(cpf) {
      cpf = this.replaceAll(cpf, ".", "");
      cpf = this.replaceAll(cpf, "-", "");
      var numeros, digitos, soma, i, resultado, digitos_iguais;
      digitos_iguais = 1;
      if (cpf.length < 11) return false;
      for (i = 0; i < cpf.length - 1; i++)
        if (cpf.charAt(i) != cpf.charAt(i + 1)) {
          digitos_iguais = 0;
          break;
        }
      if (!digitos_iguais) {
        numeros = cpf.substring(0, 9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(0)) return false;
        numeros = cpf.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(1)) return false;
        return true;
      } else return false;
    },

    replaceAll(str, de, para) {
      let pos = str.indexOf(de);
      while (pos > -1) {
        str = str.replace(de, para);
        pos = str.indexOf(de);
      }
      return str;
    },

    validarCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, "");

      if (cnpj == "") return false;

      if (cnpj.length != 14) return false;

      // Elimina CNPJs invalidos conhecidos
      if (
        cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999"
      )
        return false;

      // Valida DVs
      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;

      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(0)) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(1)) return false;

      return true;
    },

    altcpf() {
     
      if (this.cpfValido(this.cliente.cpf)) {
        this.cpfClass = "is-valid";
      } else {
        this.cpfClass = "is-invalid";
      }
    },
    altcnpj() {
      if (this.validarCNPJ(this.cliente.cnpj)) {
        this.cnpjClass = "is-valid";
      } else {
        this.cnpjClass = "is-invalid";
      }
    },

    pegaEndereco() {
      fetch("https://viacep.com.br/ws/" + this.cliente.cep + "/json")
        .then((response) => {
         
          if (response.ok) {
           
            return response.json();
          }
        })
        .then((data) => {
         
          this.cliente.endereco = data.logradouro;
          this.cliente.bairro = data.bairro;
          this.cliente.cidade = data.localidade;
          this.cliente.uf = data.uf;
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.error = error;
        });
    },
  },
};
</script>

<style scoped>

.bg-primary {
    --bs-bg-opacity: 1;
    background-color: #00a69c !important;
}
</style>
